export const CONFIG = {
  API_URL:
    process.env.REACT_APP_ENV === 'production'
      ? 'https://api.leocode.space/holiday/v1'
      : 'https://staging-api.leocode.space/holiday/v1',
  SSO_COOKIE_DOMAIN: process.env.REACT_APP_ENV === 'development' ? 'localhost' : '.leocode.space',
  SSO_COOKIE_KEY: 'leo_sso',
};
